import { render, staticRenderFns } from "./BGGRank.vue?vue&type=template&id=fe1885e6&scoped=true"
import script from "./BGGRank.vue?vue&type=script&lang=js"
export * from "./BGGRank.vue?vue&type=script&lang=js"
import style0 from "./BGGRank.vue?vue&type=style&index=0&id=fe1885e6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe1885e6",
  null
  
)

export default component.exports